export default __webpack_public_path__ + "static/media/slider2-3items.75c665d6.svg";